const colors = {
  white: "#ffffff",
  black: "#000000",
  red: "#FF0302",
  primary: "#669CFF",
  secondaryLight: "#7BD2E7",
  secondaryDark: "#2FAFD7",
  accent: "#FF78BD",
  darkGrey: "#292A37",
  darkGrey01: "rgba(0, 0, 0, 0.1)",
  lightGrey: "#F7F7FB",
  success: "#6EE4AC",
  error: "#F96B6C",

  blue: "rgba(1, 124, 255, 1)",
  newGray: "rgba(244, 245, 247, 1)",
  lightGray: "#F0F5FF",
  coolGray100: "#292A37",
  coolGray200: "#54555F",
  coolGray300: "#7F7F87",
  coolGray400: "#AAAAAF",
  coolGray500: "#D4D4D7",
  coolGray600: "#EAEAEB",
  coolGray700: "#F4F4F5",

  coolGray: "#292A37",
  coolGray8: "rgba(41, 42, 55, 0.8)",
  coolGray6: "rgba(41, 42, 55, 0.6)",
  coolGray5: "rgba(41, 42, 55, 0.5)",
  coolGray4: "rgba(41, 42, 55, 0.4)",
  coolGray2: "rgba(41, 42, 55, 0.2)",
  coolGray1: "rgba(41, 42, 55, 0.1)",
  coolGray05: "rgba(41, 42, 55, 0.05)",
  gray98: "#FAFAFA",
  secondaryDark05: "rgba(47, 175, 215, 0.05)",
  btc: "#ff9900",
  usdt: "#85E0A9",
  eth: "#9493D6",
  xrp: "#0D1D2D",
  darkRed: "#D53A19",
  lightWhite: "#D5D5D5",
  mustard: "#F3BA2F"
};

export default colors;
